import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetHost = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_Host_svg__a)"
      fillOpacity={0.5}
      d="M17.405 13.16h-14.8a.447.447 0 0 1-.445-.446V7.725a.446.446 0 0 1 .446-.445h14.8a.447.447 0 0 1 .445.445v4.99a.446.446 0 0 1-.446.445"
      opacity={0.7}
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale06)"
      fillOpacity={0.7}
      d="M7.212 8.56h-3.38a.39.39 0 0 0-.391.391v.177c0 .216.175.392.392.392h3.38a.39.39 0 0 0 .39-.392V8.95a.39.39 0 0 0-.39-.391Z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale04)"
      d="M13.155 9.47a.427.427 0 1 0 0-.854.427.427 0 0 0 0 .855Z"
      opacity={0.7}
    />
    <path
      fill="var(--dataviz-color-sequential-yellow-scale03)"
      d="M14.623 9.47a.427.427 0 1 0 0-.854.427.427 0 0 0 0 .855Z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale06)"
      d="M16.037 9.47a.427.427 0 1 0 0-.854.427.427 0 0 0 0 .855Z"
      opacity={0.7}
    />
    <defs>
      <linearGradient
        id="Asset_Host_svg__a"
        x1={14.909}
        x2={-4.653}
        y1={11.598}
        y2={10.51}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetHost;
